export function localize(
  locale: string | undefined,
  dict: Record<string, string>
): string {
  if (dict === undefined) return '';
  if (locale === undefined) locale = 'en';
  if (dict[locale]) {
    return dict[locale];
  }
  const rootCulture = locale.split('-')[0];
  if (dict[rootCulture]) {
    return dict[rootCulture];
  }
  return dict['en'];
}
